import * as React from 'react'
import styled from 'styled-typed'
import { InstructionsCard } from 'snippet/instructionsCard'
import gtmIcon from './snippetContainer/gtm.svg'
import { ActionButton } from 'uiComponents/buttons'
import { CopySnippetElement } from 'snippet/copySnippetElement'
import { Account } from 'auth/state'

const Instructions = styled.div`
    font-size: 0.875em;
    line-height: 1.785em;
    font-weight: bold;
`
const List = styled.ol`
    list-style-type: none;
    padding: 0 1em;
    counter-reset: counter;
`
const ListItem = styled.li`
    opacity: 0.75;
    counter-increment: counter;

    &::before {
        content: 'Step ' counter(counter) ': ';
        margin-left: -1em;
        padding-right: 0.1em;
    }
`
const InstructionsText = styled.div`
    margintop: 2em;
    opacity: 0.75;
    font-weight: bold;
`
const CopySnippetContainer = styled.div`
    font-size: 1.143em;
    font-weight: normal;
    margin: 1em 0 1.5em -1em;
`

interface UseGTMCardProps {
    detectSnippet: () => void
    account: Account
}

export function UseGTMCard({ detectSnippet, account }: UseGTMCardProps) {
    const closedSubHeader = 'If you use GTM all you need to do is follow the steps we mentioned here.'
    const openedSubHeader =
        'If you use Google Tag Manager all you need to do is following the steps below. \
    For more information check out the article ’Installing Convious with Google Tag Manager in 5 minutes.'

    return (
        <InstructionsCard
            iconSrc={gtmIcon}
            header="I use Google Tag Manager"
            closedSubHeader={closedSubHeader}
            openedSubHeader={openedSubHeader}
        >
            <Instructions>
                <List>
                    <ListItem>Create a New Tag from your GTM Workspace</ListItem>
                    <ListItem>Click the tag icon</ListItem>
                    <ListItem>Choose tag type &quot;Custom HTML&quot;</ListItem>
                    <ListItem>Copy the code snippet below</ListItem>
                    <CopySnippetContainer>
                        <CopySnippetElement account={account} />
                    </CopySnippetContainer>
                    <ListItem>Paste it into the HTML container</ListItem>
                    <ListItem>Click the trigger icon to set up a trigger</ListItem>
                    <ListItem>Select ‘All Pages’ and click ‘Add’ on the top-right corner</ListItem>
                    <ListItem>Save your workspace</ListItem>
                    <ListItem>Click Submit</ListItem>
                    <ListItem>Publish your changes</ListItem>
                </List>
                <InstructionsText>You’re done!</InstructionsText>
            </Instructions>
            <ActionButton size="large" style={{ marginTop: '1.5em' }} onClick={detectSnippet}>
                Check now
            </ActionButton>
        </InstructionsCard>
    )
}
